import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const SearchContainer = styled.div(({ theme }) => ({
    paddingTop: theme.spacing.large,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xLarge,
    height: "100%",
    background: theme.colorMode === "light" ? "#FFFBF7" : theme.colors.dark.canvas_Primary,
    position: "relative",
}));

export const StyledText = styled(Text)(({ theme }) => ({
    padding: `0 ${theme.spacing.medium}`,
}));

export const Wrapper = styled("div")(({}) => ({
    overflowY: "scroll",
}));

export const SearchBarWrapper = styled("div")(({ theme }) => ({
    padding: `0 ${theme.spacing.medium}`,
}));

export const FloatingWidgetContainer = styled.div(({ theme }) => ({
    bottom: theme.spacing.medium,
    padding: `0 ${theme.spacing.medium}`,
    zIndex: 2,
    position: "absolute",
    width: "100%",
}));
